const selectedTab = {
    title: 'Example JSON',
    expectedOutput: '13.1',
    initialDisplayedCode: `{
	"selectedTab": "single",
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"type": "single"
	},
	{
		"stake": 10,
		"outcomeId": 101,
		"type": "single"
	},
	{
		"stake": 100,
		"type": "combination"
	}],`,
    moreCode: `
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100
	},
	{
		"id": 101,
		"odds": 1200
	}],
	"betOffers": [],
	"hasSelectedTeaser": false,
	"selectedReward": {}
}`,
};

export default selectedTab;
